import { PlaneGeometry, BufferGeometry, BufferAttribute, Object3D, BoxGeometry } from "three";

export class BuildingGeometry
{

	public endRoofGeometry : BufferGeometry;

	constructor()
	{
		this.endRoofGeometry = BuildingGeometry.createEndRoofGeometry();
	}

	public static createPlaneGeometry(): PlaneGeometry
	{
		return new PlaneGeometry();
	}

	public static createEndRoofGeometry(symmetric = true, flip = false, cw = true, singleSlope = false, backSide = false): BufferGeometry
	{
		const endRoofGeometry = new BufferGeometry();

		const v1_x = flip ? 0.5 : -.5;
		const v1 = [v1_x, 0, 0];
		const v2_x = symmetric ? .5 : 0;
		const v2 = [v2_x, 0, 0];
		let v3 = [0, 1, 0];

		if (singleSlope === true)
		{
			if (backSide === false)
			{
				v3 = [0.5, 2, 0];
			}
			else
			{
				v3 = [-0.5, 2, 0];
			}
		}

		endRoofGeometry.setAttribute("position", new BufferAttribute(new Float32Array([v1, v2, v3].flat()), 3));

		if (cw)
		{
			endRoofGeometry.setIndex([0, 1, 2]);
		}
		else
		{
			endRoofGeometry.setIndex([0, 2, 1]);
		}

		const v2_u = symmetric ? 1 : .5;

		const uv_0 = [0, 0];
		const uv_1 = [v2_u, 0];
		const uv_2 = [.5, 1];

		const uvArray: number[] = [];

		if (cw)
		{
			uvArray.push(...[uv_0, uv_1, uv_2].flat());
		}
		else
		{
			uvArray.push(...[uv_0, uv_2, uv_1].flat());
		}

		endRoofGeometry.setAttribute("uv", new BufferAttribute(new Float32Array(uvArray), 2));

		endRoofGeometry.computeVertexNormals();

		return endRoofGeometry;
	}

	public static createWallGeometry(): PlaneGeometry
	{
		return new PlaneGeometry();
	}

	// similar to wall but vertices are moved so it's not symmetrical
	// Easier to rotate as the pivot point is on the edge
	public static createRoofGeometry(): BufferGeometry
	{
		const bufferGeometry = new PlaneGeometry();
		const dummyObject = new Object3D();
		dummyObject.position.y = 0.5;
		dummyObject.rotation.y = Math.PI / 2;
		dummyObject.updateMatrix();
		bufferGeometry.applyMatrix4(dummyObject.matrix);

		return bufferGeometry;
	}

}